var styles = {
  "main": "_main_1en3yyy_3",
  "select": "_select_1en3yyy_7",
  "sizeL": "_sizeL_1en3yyy_19",
  "rs-reset-letter-spacing": "_rs-reset-letter-spacing_1en3yyy_1",
  "sizeM": "_sizeM_1en3yyy_23",
  "sizeS": "_sizeS_1en3yyy_27"
};
export { styles as default };
